module.exports = __webpack_public_path__ + "static/media/segel.1c6e3a72.mp3";